module.exports = __webpack_public_path__ + "static/media/seo-and-web.bd7377c0.svg";